import React from 'react';
import { Alert } from '@mui/material';

interface SinUbicacionesAsignadasAlertProps {
  esAdmin?: boolean;
  sx?: object;
}

const SinUbicacionesAsignadasAlert: React.FC<SinUbicacionesAsignadasAlertProps> = ({ esAdmin = false, sx }) => {
  if (esAdmin) return null;

  return (
    <Alert severity="error" sx={{ mb: 2, borderRadius: 2, ...sx }}>
      No tiene ubicaciones asignadas. Contacte al administrador.
    </Alert>
  );
};

export default SinUbicacionesAsignadasAlert;
